import { OrgAdminConstants } from '../../../_constants';

const initialState = { getTeamMemberListLoading: true, data: '', error: false };

export function getTeamMemberListReducer(state = initialState, action) {

    switch (action.type) {
        case OrgAdminConstants.REQUEST_TEAM_MEMBERS_LIST:
            return {
                getTeamMemberListLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_TEAM_MEMBERS_LIST:
            return {
                getTeamMemberListLoading: false,
                data: action.getTeamMemberList,
                error: false
            };
        case OrgAdminConstants.TEAM_MEMBERS_LIST_ERROR:
            return {
                getTeamMemberListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/ManageTeam/getTeamMemberList.reducer.js